module.exports = __webpack_public_path__ + "static/media/photo-12.61d23959.jpg";